import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f88628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "authors" }
const _hoisted_4 = { class: "name line1" }

import all, {State} from '@/store/channels/channel_all'
import * as filters from '@/views/filters'
import {computed, reactive} from 'vue'
import {useStore} from 'vuex'
import Request from '../Request.vue'

import i18, {State as I18State} from '@/store/i18'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const i18data = computed<I18State>(() => store.state[i18.name])
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

const data = computed<State>(() => store.state[all.name])
const temp = reactive({
    requestVisible: false,
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_unref(channelLang).allChannels), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "item",
          to: `/channels/detail/${item.id}.html`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "avatar",
              style: _normalizeStyle(_unref(filters).bg(item.thumb))
            }, null, 4),
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ]),
    (_unref(temp).requestVisible)
      ? (_openBlock(), _createBlock(Request, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(temp).requestVisible = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})